import { DictionariesService } from '@sa/rep-mdm';
import { useEffect, useMemo, useState } from 'react';
import { useHookSubscribe } from '../../react-rxjs';
import { ServicesMaps } from '../MapReportingProvider';
import { MapDataSource, MapDataSourceId } from '../models/MapDataSource';
import { MapDimension } from '../models/MapDimension';
import { useMapDimension } from './useMapDimension';
import { useMapStore } from './useMapStore';
import { useService } from './useService';
import * as React from 'react';
import { MapDataCountry } from '../models/MapDataCountry';
import { uniq } from '../../../shared';

export function useMapSource() {
  const store = useMapStore();
  const loadingDataSources = useHookSubscribe<boolean>(true, store.loadingDataSources$);
  const loadingDimensions = useHookSubscribe<boolean>(true, store.loadingDimensions$);
  const loadingData = useHookSubscribe<boolean>(true, store.loadingData$);
  const data = useHookSubscribe<Map<string, MapDataCountry>>(new Map(), store.data$);
  const loading = loadingDataSources || loadingDimensions || loadingData;
  const dataSource = useHookSubscribe<null | MapDataSource>(null, store.dataSource$);
  const [dataSources, setDataSources] = React.useState<IDataSource[]>([]);
  const dictionariesService = useService<DictionariesService>(ServicesMaps.Dictionaries);
  React.useEffect(() => {
    (async () => {
      const items = await fetchDataSources(dictionariesService);
      setDataSources(items);
    })();
  }, [dictionariesService]);

  const sourceResult = React.useMemo(() => {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short' });
    if (dataSource?.id === MapDataSourceId.HarmonizedDataset) {
      const allSourcesNames = Array.from(data.values()).map(e => e.source).filter(Boolean);
      const uniqSourcesNames = uniq(allSourcesNames);
      const resultSources = uniqSourcesNames.map(name => {
        const candidateItem = dataSources.find(ds => normolizeDataSourseName(ds.name) === normolizeDataSourseName(name));
        const formatedDate = candidateItem?.updateDate ? dateFormatter.format(candidateItem!.updateDate!) : '';
        return [name, formatedDate].filter(Boolean).join(' ');
      });
      return resultSources.filter(Boolean).join(', ') || ' ';
    }
    return `${dataSource?.name} ${dataSource?.updateDate ? dateFormatter.format(dataSource.updateDate) : ''}`;
  }, [dataSource, data, dataSources]);
  return loading ? '' : sourceResult;
}

interface IDataSource {
  name: string;
  updateDate?: Date;
}
async function fetchDataSources(dictionariesService: DictionariesService) {
  const dictionary = await dictionariesService.getDictionary({ id: 'v_dict_sources_harm', parameters: {} });
  const items = await dictionary.getAll();

  return items.map<IDataSource>(e => ({
    name: (typeof e.getValue("id") === "object" ? e.getValue<Record<number, string>>("id")?.[9] : e.getValue<string>("id")) || '',
    updateDate: e.getValue<string>('lastUpdate') ? new Date(e.getValue<string>('lastUpdate')!) : undefined,
  }));
}

function normolizeDataSourseName(name?: string) {
  return name?.toLowerCase().trim().replaceAll('&', '').replaceAll(' ', '');
}